import styled from 'styled-components'
import { Column } from '../../../../../styles/styledGlobal'

export const FlexIcon = styled.div`
display: flex;
align-items: center;
label{
    margin-right: .5rem;
}

svg{
    cursor: pointer;
}
`

export const CardColor = styled.div`
    height: 12rem;
    min-width: 10rem;
    max-width: 10rem;
    background: #${props => props.theme};
    color: white;
    display: flex;
    align-items: center;
    border-radius: 0.625rem;
    padding: .5rem;
    font-family: 'Poppins','sans-serif';
    small{
        width: 8.813rem;
        word-break: break-word;
        font-size: 1.125rem;
        text-align: center;
    }
`

export const PaletaDeCor = styled(Column)`
margin-top: 1rem;

div{
    display: flex;
    flex-wrap: wrap;
}

`

export const ColorBox = styled.div`
background: #${props => props.theme};
height: 2rem;
width: 2rem;
margin-right: 0.5rem;
margin-bottom: 0.5rem;
cursor: pointer;
border-radius: 0.313rem;
`

export const InputColor = styled.div`
div{
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--c3);
    padding: 0rem .5rem 0rem .5rem;
    color: var(--c6);
    height: 2rem;
    font-size: 1rem;
    border-top-left-radius: 0.313rem;
    border-bottom-left-radius: 0.313rem;
}

input{
    height: 2rem;
    padding-left: 0.6rem;
    border-top-right-radius: 0.313;
    border-bottom-right-radius: 0.313;
    border-bottom-left-radius:0rem;
    border-top-left-radius: 0rem;
    margin-bottom: .5rem;
    width: 8rem;
    box-sizing: border-box;
    outline: none;
    border: 0.063rem solid var(--c2);
    padding: 0.5rem;
    font-size: 1rem;
    color: var(--a4);
    background-color: var(--c2);
    
    ::placeholder {
          opacity: 70%;  
    }

    &:focus {
      border: 0.063rem solid var(--v2);
    }
}
`

export const TagBox = styled(Column)`
margin-top: .5rem;
& > div{
    display: flex;
    flex-wrap: wrap;
}
`
